module.exports = __webpack_public_path__ + "img/Dental Care.3066cc4c.png";